function MarshallIsland({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1598)">
  <path d="M16 32C24.8365 32 32 24.8365 32 16C32 13.3148 31.3375 10.7846 30.1686 8.5625L15.9812 16.0187L23.4375 1.83138C21.2154 0.6625 18.6852 0 16 0C7.1635 0 0 7.1635 0 16C0 20.4183 1.79088 24.4183 4.68625 27.3137C7.58169 30.2092 11.5817 32 16 32Z" fill="#0052B4"/>
  <path d="M30.1518 8.58019C29.4194 7.18619 28.4672 5.87738 27.2951 4.70526C26.1229 3.53313 24.8143 2.58095 23.4202 1.84863L4.6676 27.3327L30.1518 8.58019Z" fill="#F0F0F0"/>
  <path d="M4.6676 27.3325L30.1518 8.58002C29.4194 7.18602 28.4672 5.8772 27.2951 4.70508L4.6676 27.3325Z" fill="#FF9811"/>
  <path d="M13.8942 9.38226L11.9402 10.3014L12.9808 12.1939L10.8589 11.7879L10.59 13.9314L9.11202 12.3549L7.63402 13.9314L7.36527 11.7879L5.2434 12.1938L6.28383 10.3013L4.32983 9.38226L6.2839 8.46307L5.2434 6.5707L7.36515 6.97651L7.63408 4.83301L9.11202 6.40957L10.59 4.83301L10.8589 6.97651L12.9808 6.5707L11.9403 8.46313L13.8942 9.38226Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default MarshallIsland;
